import { __awaiter, __decorate, __generator } from "tslib";
import { singleton } from 'tsyringe';
var relativeDictionaryUrl = '/public-api/dictionaries/cart';
var BasketTranslationService = /** @class */ (function () {
    function BasketTranslationService() {
    }
    Object.defineProperty(BasketTranslationService.prototype, "translations", {
        get: function () {
            return this._translations ? this._translations : this._translations = this.getTranslations();
        },
        enumerable: false,
        configurable: true
    });
    BasketTranslationService.prototype.getTranslations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dictionaryUrl, translationsResponse, translations;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dictionaryUrl = "".concat(typeof baseDictionaryUrl === 'string' ? baseDictionaryUrl : '').concat(relativeDictionaryUrl);
                        return [4 /*yield*/, fetch(dictionaryUrl).catch(function () { return null; })];
                    case 1:
                        translationsResponse = _a.sent();
                        translations = translationsResponse.ok ? translationsResponse.json() : Promise.resolve({});
                        return [2 /*return*/, translations];
                }
            });
        });
    };
    BasketTranslationService = __decorate([
        singleton()
    ], BasketTranslationService);
    return BasketTranslationService;
}());
export { BasketTranslationService };
